export default __webpack_public_path__ + "static/media/arrow-down.8ced0fc3.svg";